import { get } from 'lodash'
import { email, requiredCheck, required } from 'utils/validation'

export default function(values) {
  const qualifications = requiredCheck(
    get(values, 'universityDegree')
    || get(values, 'tafeQualification')
    || get(values, 'apprenticeship')
    || get(values, 'experience')
    || get(values, 'membership')
    || get(values, 'nonAccreditedTraining')
    || get(values, 'organisational')
    || get(values, 'peakBody')
  )

  return {
    // assessor
    email: email(get(values, 'email')),
    secondaryEmail: email(get(values, 'secondaryEmail')),
    tertiaryEmail: email(get(values, 'tertiaryEmail')),
    // activity
    peakBody: qualifications,
    activityCategory: {
      id: required(get(values, 'activityCategory.id'))
    }
  }
}
export const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  const defaultResponse = { body: { value: false } }

  const email = get(values, 'email')

  const secondaryEmail = get(values, 'secondaryEmail')

  const tertiaryEmail = get(values, 'tertiaryEmail')

  if (get(props, 'forActivityRegistration')) {
    return Promise.resolve({})
  }
  const promises = Promise.all([
    props.checkEmail({ email, checkAlternativeEmails: true }).catch(() => defaultResponse),
    props.checkEmail({ email: secondaryEmail, checkAlternativeEmails: true }).catch(() => defaultResponse),
    props.checkEmail({ email: tertiaryEmail, checkAlternativeEmails: true }).catch(() => defaultResponse)
  ])
  const EMAIL_IN_USE = {
    text: 'E-mail address is already in use.',
    intlKey: 'errors.email_address_is_in_use'
  }

  const SAME_EMAILS = {
    text: 'E-mail cannot be the same.',
    intlKey: 'errors.emails_cannot_be_same'
  }

  return promises
    .then(r => {
      const [primaryEmailRes, secondaryEmailRes, tertiaryEmailRes] = r

      const errors = {
        secondaryEmail: secondaryEmailRes.body.value ? EMAIL_IN_USE : undefined,
        tertiaryEmail: tertiaryEmailRes.body.value ? EMAIL_IN_USE : undefined,
      }

      if (email === tertiaryEmail || (secondaryEmail && tertiaryEmail && secondaryEmail === tertiaryEmail)) {
        // eslint-disable-next-line
        throw { tertiaryEmail: SAME_EMAILS }
      }

      if (email === secondaryEmail) {
        // eslint-disable-next-line
        throw { secondaryEmail: SAME_EMAILS }
      }


      if (Object.values(errors).some(v => v)) {
        throw errors
      }
    })
}
